import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { PaymentResultType } from "@/stores/EngineStore/enums/PaymentResultType.ts";
import { useLayoutEffect } from "react";
import { useShallow } from "zustand/react/shallow";

export const usePaymentResultURLParam = () => {
  const { setPaymentResult, page, setPage, resetAll } = useEngineStore(
    useShallow((state) => ({
      setPaymentResult: state.setPaymentResult,
      page: state.page,
      setPage: state.setPage,
      resetAll: state.resetAll,
    })),
  );

  // useLayoutEffect for better recognisition
  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentResultType = urlParams.get(URLParam.PaymentResult) as PaymentResultType | null;

    if (!paymentResultType) {
      if (page === AppPage.PaymentResult) setPage(AppPage.AccommodationPicking);
      return;
    }

    if (paymentResultType === PaymentResultType.Success) {
      resetAll(true);
      setPaymentResult(paymentResultType);
    } else {
      // On cancellation or error, preserve cart state and go back to ReservationOverview
      urlParams.delete(URLParam.PaymentResult);
      history.replaceState(null, "", `${window.location.pathname}?${urlParams.toString()}`);
      setPage(AppPage.ReservationOverview);
    }

    // eslint-disable-next-line
  }, [window.location.search]);
};
